import React, { useState } from 'react';
import { Box, Typography, Button, Modal } from '@mui/material';

const Upload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = useState(false);

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      console.log('Selected file:', file);
    }
  };

  // Handle modal open/close
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle upload button click
  const handleUploadClick = () => {
    if (selectedFile) {
      alert(`File "${selectedFile.name}" selected for upload.`);
      handleClose(); // Close the modal after upload
    } else {
      alert('Please select a file first.');
    }
  };

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        backgroundColor: '#B2C770', // Light green background
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: 2,
      }}
    >
      {/* Main Heading */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontFamily: 'Inter, sans-serif',
          color: '#000',
        }}
      >
        PICTURE TO{' '}
        <Box component="span" sx={{ color: '#BD5E1F' }}>
          INSIGHTS
        </Box>{' '}
        IN MINUTES
      </Typography>

      {/* Subheading */}
      <Typography
        variant="body1"
        sx={{
          mt: 3,
          maxWidth: '500px',
          fontSize: '1rem',
          fontFamily: 'Inter, sans-serif',
          color: '#000',
        }}
      >
        Upload a picture, and we will highlight any mangrove trees for you.
      </Typography>

      {/* Open Modal Button */}
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          mt: 4,
          backgroundColor: '#000',
          color: '#fff',
          borderRadius: '20px',
          px: 4,
          py: 1.5,
          textTransform: 'none',
          '&:hover': {
            backgroundColor: '#222',
          },
        }}
      >
        Upload
      </Button>

      {/* Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="upload-modal-title"
        aria-describedby="upload-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: '10px',
            textAlign: 'center',
          }}
        >
          {/* Dynamic Title */}
          <Typography
            id="upload-modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            {selectedFile ? `Selected File: ${selectedFile.name}` : 'Upload Your File'}
          </Typography>

          {/* File Input */}
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            id="file-upload"
            onChange={handleFileChange}
          />
          <label htmlFor="file-upload">
            <Button
              variant="contained"
              component="span"
              sx={{
                mt: 2,
                backgroundColor: '#000',
                color: '#fff',
                borderRadius: '20px',
                px: 4,
                py: 1.5,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#222',
                },
              }}
            >
              Choose File
            </Button>
          </label>

          {/* Upload Button */}
          <Button
            variant="contained"
            onClick={handleUploadClick}
            sx={{
              mt: 2,
              backgroundColor: '#000',
              color: '#fff',
              borderRadius: '20px',
              px: 4,
              py: 1.5,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#222',
              },
            }}
          >
            Upload
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default Upload;